import actionConsts from "./../../constants/actions";
import sortBy from "lodash/sortBy";
import _ from "lodash";

const isStarredFieldPresent = array => {
	return array.some(mailAction => mailAction.type === "starred");
};

const isDraftPresent = array => {
	return array.some(mailAction => mailAction.type === "draft");
};

const areSurveyAnswersPresent = array => {
	return array.some(mailAction => mailAction.type === "survey");
};

const createActorArray = actors => {
	let actorList = [...actors.inActors, ...actors.clients];
	let result = {};

	actorList.map(item => {
		result = {
			...result,
			[`{{actor_${item.id}}}`]: item.first_name + ' ' + item.last_name,
			[`{{actor_first_name_${item.id}}}`]: item.first_name
		}
	})

	return result
}

const replacePlaceHolderWithActorName = (str, actorArray) => {
	let regex = /{{(\w+)}}/g;
	let found = str.match(regex);

	if (found && found.length > 0) {
		found.map(item => {
			str = str.replace(item, actorArray[item])
		})
	}

	return str;
}

const setActorStrings = (actorArray, mails) => {
	let bodyWithRandomizedActors, repliesWithRandomizedActors, tempList, callquestions, callstatements;

	return mails.map(mail => {
		//replacing actors in subject
		mail.subject = replacePlaceHolderWithActorName(mail.subject, actorArray)

		//Replacing actors in mail body
		if (mail.body) {
			bodyWithRandomizedActors = mail.body.map(item => {
				return replacePlaceHolderWithActorName(item, actorArray)
			})
			mail.body = bodyWithRandomizedActors
		}

		//Replacing actors in reply mail
		if (mail.replyMailOptions) {
			repliesWithRandomizedActors = mail.replyMailOptions.rol.map(list => {
				tempList = list.options.map(item => {
					return { ...item, text: replacePlaceHolderWithActorName(item.text, actorArray) }
				})
				list.options = tempList
				return list
			})
			mail.replyMailOptions.rol = repliesWithRandomizedActors
		}

		// Replacing actors in call/meeting
		if (mail.survey) {
			callquestions = mail.survey.questions.map(list => {
				tempList = list.options.map(item => {
					return { ...item, text: replacePlaceHolderWithActorName(item.text, actorArray) }
				})
				list.options = tempList
				return list
			})

			callstatements = mail.survey.statements.map(item => {
				return { ...item, text: replacePlaceHolderWithActorName(item.text, actorArray) }
			})

			mail.survey.questions = callquestions
			mail.survey.statements = callstatements
		}

		return mail
	})
}

const randomizeOptionSequence = (mails, userId) => {
	let randomizedROL, optionsList;
	return mails.map(mail => {
		if (!mail.replyMailOptions) {
			return mail;
		} else {
			randomizedROL = mail.replyMailOptions.rol.map(list => {
				optionsList = list.options.map(item => {
					return { ...item, index: (item.index + userId) % list.options.length }
				})
				optionsList = _.orderBy(optionsList, ["index"], ["asc"]);
				list.options = optionsList;
				return list;
			});
			mail.replyMailOptions.rol = randomizedROL;
			return mail;
		}
	});
};

const setSurveyQuestionsSequence = (mails, sequences, user) => {
	// Setting the survey questions order here. This is done before the game begins
	let surveyMail = mails.find(mail => mail.type === "survey");
	let selectedSequence = sequences.find(
		item => item.id === user.surveySequenceId
	).sequence;
	let sortedSequence = [];

	sortedSequence = selectedSequence.map(item => {
		return surveyMail.survey.questions[item - 1];
	});

	mails.map(item => {
		if (item.id !== surveyMail.id) {
			return item;
		} else {
			item.survey.questions = sortedSequence;
			return item;
		}
	});

	return mails;
};

const actionThreadReducer = (state = null, action = {}) => {
	const { payload } = action;
	switch (action.type) {
		case actionConsts.ADD_SHOW_MAIL_FLAG:
			if (!state) {
				return [
					{
						type: "isShown",
						status: true
					}
				];
			} else {
				return [
					...state,
					{
						type: "isShown",
						status: true
					}
				];
			}

		case actionConsts.SAVE_DRAFT:
			let mailDraft = {
				type: "draft",
				to: payload.to,
				cc: payload.cc
			};
			let draftBody = payload.messageOptionsList.map(list => {
				if (list) {
					if (list.type === "mcq") {
						return {
							messageGroupId: list.messageGroupId,
							optionId: list.optionId
						};
					} else {
						return {
							messageGroupId: list.messageGroupId,
							options: list.selectedOptions
						};
					}
				}
			});
			mailDraft.body = draftBody;

			if (!isDraftPresent(state)) {
				return [...state, mailDraft];
			} else {
				return state.map(mailAction => {
					if (mailAction.type === "draft") {
						return mailDraft;
					}
					return mailAction;
				});
			}

		case actionConsts.VIEW_SENT_MAIL:
			let composeBodyOption = {
				type: "compose",
				to: payload.to,
				cc: payload.cc
			};

			let body = payload.messageOptionsList.map(list => {
				if (list) {
					if (list.type === "mcq") {
						return {
							messageGroupId: list.messageGroupId,
							optionId: list.optionId
						};
					} else {
						return {
							messageGroupId: list.messageGroupId,
							choosenOptions: list.choosenOptions
						};
					}
				}
			});
			composeBodyOption.body = body;
			if (isDraftPresent(state)) {
				state = state.filter(mailAction => mailAction.type !== "draft");
			}
			return [...state, composeBodyOption];

		case actionConsts.GET_NEXT_MAIL:
			let nextMail = {
				type: "next_mail",
				mailId: payload.nextMailId
			};
			return [...state, nextMail];

		case actionConsts.ADD_MAIL_READ_FLAG:
			return [
				...state,
				{
					type: "mail_read",
					status: true
				}
			];

		case actionConsts.ADD_MAIL_STARRED_FLAG:
			if (!isStarredFieldPresent(state)) {
				return [
					...state,
					{
						type: "starred",
						status: true
					}
				];
			} else {
				return state.map(mailAction => {
					if (mailAction.type === "starred") {
						mailAction.status = true;
					}
					return mailAction;
				});
			}

		case actionConsts.REMOVE_MAIL_STARRED_FLAG:
			return state.map(mailAction => {
				if (mailAction.type === "starred") {
					return {
						type: "starred",
						status: false
					};
				} else {
					return mailAction;
				}
			});

		case actionConsts.SET_SURVEY_COMPLETED_FLAG:
			return [
				...state,
				{
					type: "call_terminated"
				}
			];

		case actionConsts.SAVE_SURVEY_ANSWER:
			if (areSurveyAnswersPresent(state)) {
				//if answering for the second time and later
				return state.map(mailAction => {
					if (mailAction.type === "survey") {
						let mailAnswers = {};
						if (
							mailAction.answers.some(
								answer =>
									answer.questionId === payload.questionId
							)
						) {
							//if answer to a question already exists
							mailAnswers = mailAction.answers.map(answer => {
								if (answer.questionId === payload.questionId) {
									return {
										questionId: payload.questionId,
										optionId: payload.optionId
									};
								}
								return answer;
							});
						} else {
							//adding a new answer
							mailAnswers = [
								...mailAction.answers,
								{
									questionId: payload.questionId,
									optionId: payload.optionId
								}
							];
						}
						return {
							type: "survey",
							answers: mailAnswers
						};
					}
					return mailAction;
				});
			} else {
				//if answering for the first time
				return [
					...state,
					{
						type: "survey",
						answers: [
							{
								questionId: payload.questionId,
								optionId: payload.optionId
							}
						]
					}
				];
			}

		// let surveyFlag = {
		//     "type": "survey"
		// };
		// return [...state, surveyFlag];

		default:
			return state;
	}
};

const mails = (state = [], action = {}) => {
	const { payload } = action;
	switch (action.type) {
		case actionConsts.RECEIVE_INIT_DATA:
			let tutorialData = payload.tutorial.tutorialData;
			return [...state, ...tutorialData.mails];

		case actionConsts.SET_MAILS:
			let actorArray = createActorArray(payload.actors)
			let newMails = setActorStrings(actorArray, payload.mails);
			let mails = randomizeOptionSequence(newMails, payload.user.userId);

			//set survey questions order here
			return setSurveyQuestionsSequence(
				mails,
				payload.survey_sequences,
				payload.user
			);

		case actionConsts.RESTART_TUTORIAL:
			return payload.mails;

		case actionConsts.ADD_SHOW_MAIL_FLAG:
			//TODO: If call/meeting is the first mail, there is some issue with id.
			let newState = state.map(mail => {
				if (mail.id === payload.mailId) {
					return {
						...mail,
						receivedAtTime: payload.expectedAtTime,
						actionThread: actionThreadReducer(
							mail.actionThread,
							action
						)
					};
				}
				return mail;
			});
			return sortBy(newState, mail => mail.expectedAt);

		case actionConsts.ADD_SHOW_CALL_FLAG:
			return state.map(call => {
				if (call.id === payload.call.id) {
					return {
						...call,
						receivedAtTime: payload.expectedAtTime
					};
				}
				return call;
			});

		case actionConsts.ADD_SHOW_MEETING_FLAG:
			return state.map(meeting => {
				if (meeting.id === payload.meeting.id) {
					return {
						...meeting,
						receivedAtTime: payload.expectedAtTime
					};
				}
				return meeting;
			});

		case actionConsts.SAVE_DRAFT:
			return state.map(mail => {
				if (mail.id === payload.primaryMailId) {
					return {
						...mail,
						actionThread: actionThreadReducer(
							mail.actionThread,
							action
						)
					};
				}
				return mail;
			});

		case actionConsts.VIEW_SENT_MAIL:
			return state.map(mail => {
				if (mail.id === payload.primaryMailId) {
					return {
						...mail,
						actionThread: actionThreadReducer(
							mail.actionThread,
							action
						)
					};
				}
				return mail;
			});

		case actionConsts.GET_NEXT_MAIL:
			return state.map(mail => {
				if (mail.id === payload.primaryMailId) {
					return {
						...mail,
						actionThread: actionThreadReducer(
							mail.actionThread,
							action
						)
					};
				}
				return mail;
			});

		case actionConsts.ADD_MAIL_READ_FLAG:
			return state.map(mail => {
				if (mail.id === payload) {
					return {
						...mail,
						actionThread: actionThreadReducer(
							mail.actionThread,
							action
						)
					};
				}
				return mail;
			});

		case actionConsts.ADD_MAIL_STARRED_FLAG:
			return state.map(mail => {
				if (mail.id === payload) {
					return {
						...mail,
						actionThread: actionThreadReducer(
							mail.actionThread,
							action
						)
					};
				}
				return mail;
			});

		case actionConsts.REMOVE_MAIL_STARRED_FLAG:
			return state.map(mail => {
				if (mail.id === payload) {
					return {
						...mail,
						actionThread: actionThreadReducer(
							mail.actionThread,
							action
						)
					};
				}
				return mail;
			});

		case actionConsts.SET_SURVEY_COMPLETED_FLAG:
			return state.map(mail => {
				if (mail.id === payload) {
					return {
						...mail,
						actionThread: actionThreadReducer(
							mail.actionThread,
							action
						)
					};
				}
				return mail;
			});

		case actionConsts.SAVE_SURVEY_ANSWER:
			return state.map(mail => {
				if (mail.id === payload.primaryMailId) {
					return {
						...mail,
						actionThread: actionThreadReducer(
							mail.actionThread,
							action
						)
					};
				}
				return mail;
			});

		case actionConsts.START_CALL:
			return state.map(call => {
				if (call.id === payload) {
					return {
						...call,
						actionThread: [
							...call.actionThread,
							{
								type: "call_started",
								status: "true"
							}
						]
					};
				}
				return call;
			});

		case actionConsts.TERMINATE_CALL:
			return state.map(call => {
				if (call.id === payload) {
					return {
						...call,
						actionThread: [
							...call.actionThread,
							{
								type: "call_terminated",
								status: "true"
							}
						]
					};
				}
				return call;
			});

		// case actionConsts.SET_MAIL_RECEIVED_AT_TIME:
		//     return state.map(mail => {
		//         let expectedAtTime = Math.floor(payload.totalTime * (100 - mail.expectedAt) / 100);
		//         let currentTime = payload.timeLeft;

		//         let receivedAtTime = Math.floor((expectedAtTime - currentTime) / 60)
		//         if (isNaN(receivedAtTime)) {
		//             receivedAtTime = 0;
		//         }
		//         return { ...mail, receivedAtTime: receivedAtTime }
		//     })

		default:
			return state;
	}
};

export default mails;



// WEBPACK FOOTER //
// /src/reducers/mail/index.js